import * as React from 'react';
import { observable, makeObservable } from 'mobx';
import { SessionReservationPaneState } from './states/SessionReservationPaneState';
import { inject, observer } from 'mobx-react';
import { ReservationPane, ReservationSubPane, ReservationSubPanes } from '../../atoms/reservations/ReservationPane';
import { ReservationPaneHeader } from '../../atoms/reservations/ReservationPaneHeader';
import { ReservationSummaryPane } from '../../molecules/reservations/ReservationSummaryPane';
import { ReservationActionPane } from '../../molecules/reservations/ReservationActionPane';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { BackButton } from '../../../../commonv3/components/atoms/buttons/BackButton';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { V3Routes } from '../../../routes';
import { Link } from 'react-router-dom';
import './sessionReservationPane.module.scss';
import { SessionType } from '../../../types/sessions';
import { CoachingPageState } from '../../../containers/coaching/states/CoachingPageState';
import { Alert, AlertContent } from '@sheinc/shelikes-design-system';

type Props = {
  homeState: HomePageState | CoachingPageState;
  match: {
    url: string;
    params: {
      sessionId: string;
    };
  };
};

export const SessionReservationPane = inject('homeState')(
  observer(
    class SessionReservationPane extends React.Component<Props> {
      paneState: SessionReservationPaneState = null;

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          paneState: observable,
        });

        this.paneState = new SessionReservationPaneState(props.homeState);
      }

      componentDidMount(): void {
        this.init();
      }

      componentDidUpdate(prevProps: Readonly<Props>): void {
        if (this.props.match.params.sessionId !== prevProps.match.params.sessionId) {
          this.init();
        }
      }

      init() {
        this.paneState.init(Number(this.props.match.params.sessionId));
      }

      render() {
        const { submitting, submit, session: sessionResource, exceedsMokumokuLimit } = this.paneState;
        if (sessionResource.loading) {
          return (
            <ReservationPane>
              <BackButton />
              <ReservationPaneHeader>予約内容の確認</ReservationPaneHeader>
              <ReservationSubPane>
                <LoaderRow />
              </ReservationSubPane>
            </ReservationPane>
          );
        }
        if (sessionResource.isNotFound()) {
          return <NotFoundPage />;
        }
        const session = sessionResource.get();
        const disabled = exceedsMokumokuLimit && session.session_type == SessionType.MOKUMOKU;
        return (
          <ReservationPane>
            <BackButton />
            <ReservationPaneHeader>予約内容の確認</ReservationPaneHeader>
            {session.session_type == SessionType.MOKUMOKU && <MokumokuReservationAttention />}
            {session.session_type == SessionType.MULTICREATOR_CAREER_COACHING && (
              <MulticreatorCareerCoachingReservationAttention />
            )}
            <ReservationSubPanes>
              <ReservationSummaryPane title={session.template_name} reservable={session} />
              <ReservationActionPane submitting={submitting} onSubmit={submit} disable={disabled} />
            </ReservationSubPanes>
          </ReservationPane>
        );
      }
    }
  )
);

export const MokumokuReservationAttention = () => (
  <div styleName="warning_wrapper">
    <Alert>
      <AlertContent
        description={
          <>
            予約できる枠数は最大3つまでとさせて頂いております。
            <br />
            現在予約中のもくもく会については、マイページの<Link to={V3Routes.reservations()}>予約一覧</Link>
            よりご確認ください。
          </>
        }
      />
    </Alert>
  </div>
);
export const MulticreatorCareerCoachingReservationAttention = () => (
  <div styleName="warning_wrapper">
    <Alert>
      <AlertContent description="予約いただいた1on1キャリアコーチングの日程は、変更・キャンセルができないのでご了承ください" />
    </Alert>
  </div>
);
